








































































import {
	computed,
	defineComponent,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import { useConfirmDialog } from '@vueuse/core';
import {
	ALL_ROLES,
	isNotNoneRole,
	PROFESSIONAL_ROLES,
	UserDetailRoleNoNone,
} from '@front-app/services/UserApi/UserModel';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import Checkbox from '@front-app/components/inputs/Checkbox.vue';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import ProfileCard from '@front-app/components/userProfile/ProfileCard.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { hasValidRolesForSpecialty } from '@front-app/util/user';
import { Size } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import FormError from '@front-app/components/form/FormError.vue';

export default defineComponent({
	components: {
		Checkbox,
		ConfirmationModal,
		CtaButton,
		LoaderState,
		ProfileCard,
		FormError,
	},
	props: {
		isLoadingSpecialties: Boolean,
		onlyShowProfessionalRoles: Boolean,
		confirmUpdate: Boolean,
		numRolesRequired: {
			type: Number,
			default: 0,
		},
	},
	setup(props, ctx) {
		const { currentUser } = CurrentUserStore;

		const showInsufficientNumRolesError = ref(false);
		const roles: Ref<UserDetailRoleNoNone[]> = ref([]);
		const availableRoles = computed(() => {
			if (props.onlyShowProfessionalRoles) {
				return ALL_ROLES.filter((role) => PROFESSIONAL_ROLES.includes(role));
			}
			return ALL_ROLES;
		});
		const numSelectedAvailableRoles = computed(() => availableRoles
			.value
			.filter((availableRole) => roles.value.includes(availableRole))
			.length);

		const confirmUpdateModal = useConfirmDialog();

		const addSpecialtiesModal = useConfirmDialog();
		const confirmAddingSpecialties = () => {
			addSpecialtiesModal.confirm();
			ctx.emit('add-specialties');
		};

		const toggleRole = (role: UserDetailRoleNoNone) => {
			showInsufficientNumRolesError.value = false;
			if (roles.value.includes(role)) {
				roles.value = roles.value.filter((val) => val !== role);
			} else {
				roles.value = roles.value.concat(role);
			}
		};

		const {
			track,
			isLoading,
		} = useAsyncStatus();
		const saveRoles = async () => {
			if (props.numRolesRequired > numSelectedAvailableRoles.value) {
				showInsufficientNumRolesError.value = true;
				return;
			}
			await track(CurrentUserStore.actions.updateRoles(roles.value));
			ctx.emit('saved');

			// Display confirmation modal to prompt user to add specialties for the following valid roles
			if (hasValidRolesForSpecialty(roles.value)) {
				addSpecialtiesModal.reveal();
			}
		};
		const saveRolesOnConfirm = async () => {
			await saveRoles();
			confirmUpdateModal.confirm();
		};

		watch(() => currentUser.value.roles, (curr) => {
			// Some roles (eg: CSR) aren't supported in this UI, but will be persisted by the BE anyway
			roles.value = curr
				.filter(isNotNoneRole)
				.filter((r) => ALL_ROLES.includes(r));
		}, { immediate: true });

		return {
			numSelectedAvailableRoles,
			showInsufficientNumRolesError,
			availableRoles,
			roles,
			confirmUpdateModal,
			toggleRole,
			saveRoles,
			saveRolesOnConfirm,
			// Adding specialties
			addSpecialtiesModal,
			confirmAddingSpecialties,
			isLoading,
			ButtonPalettes,
			Size,
		};
	},
});
